module.exports = __webpack_public_path__ + "static/media/spanish-articles.5e927be4.png";